module.exports = __webpack_public_path__ + "static/media/biotech.b480b585.png";